export const selectScore = (state) => state.gameState.score;
export const selectMusicPlaying = (state) => state.gameState.musicPlaying;
